const BowlingBallIcon = /*#__PURE__*/ [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 6V6.01", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", key: "1" }],
  ["path", { d: "M18 9V9.01", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", key: "2" }],
  ["path", { d: "M14 10V10.01", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "2", key: "3" }]
];

export { BowlingBallIcon as default };
//# sourceMappingURL=BowlingBallIcon.js.map
